import React from "react";
import { METHODOLOGY } from "@/mock";
import { Card } from "@/components/ui/card";
import { ArrowRight, Check, Sparkles } from "lucide-react";
import { DEFAULT_SITE_COPY, useSiteCopy, PageShell, PrimaryCTA, ResponseBadge } from "./publicShared";

export const HowItWorksContent = () => {
  const { copy } = useSiteCopy();

  return (
    <PageShell>
      <h1 className="text-3xl font-semibold tracking-tight text-foreground dark:text-white">
        How it works
      </h1>
      <p className="mt-3 max-w-2xl text-foreground/65 dark:text-white/65">
        A 4-step progression designed to de-risk outcomes.
      </p>

      <div className="mt-10 grid gap-4 md:grid-cols-2">
        {METHODOLOGY.map((m) => (
          <Card
            key={m.step}
            className="rounded-3xl border-border/60 dark:border-white/10 bg-background/60 dark:bg-white/5 p-6 backdrop-blur-2xl"
          >
            <div className="text-foreground/80 dark:text-white/80">{m.step}</div>
            <div className="mt-2 text-lg font-semibold text-foreground dark:text-white">
              {m.detail}
            </div>
            <div className="mt-5 rounded-2xl border border-border/60 dark:border-white/10 bg-muted/60 dark:bg-black/30 p-4 text-sm text-foreground/65 dark:text-white/65">
              You'll see clear gates at each step: free call -&gt; paid assessment
              -&gt; action plan -&gt; implementation.
            </div>
          </Card>
        ))}
      </div>

      <div className="mt-12 grid gap-4 md:grid-cols-2">
        <Card className="rounded-3xl border-border/60 dark:border-white/10 bg-background/60 dark:bg-white/5 p-6 backdrop-blur-2xl">
          <div className="text-sm font-semibold text-foreground dark:text-white">
            What you get every time
          </div>
          <ul className="mt-4 space-y-3 text-sm text-foreground/65 dark:text-white/65">
            {[
            "Client Portal -> Deliverables Center",
            "Results visible in your tenant",
            "PDF report downloads",
            "Meeting recap notes + decisions + owners",
            "Implementation proposal/Scope of Services (when applicable)"].
            map((x) =>
            <li key={x} className="flex gap-2">
                <Check className="mt-0.5 h-4 w-4 text-[var(--brand)]" />
                <span>{x}</span>
              </li>
            )}
          </ul>
        </Card>

        <Card className="rounded-3xl border-border/60 dark:border-white/10 bg-background/60 dark:bg-white/5 p-6 backdrop-blur-2xl">
          <div className="text-sm font-semibold text-foreground dark:text-white">
            High-touch, minimal friction
          </div>
          <p className="mt-3 text-sm leading-relaxed text-foreground/65 dark:text-white/65">
            Clients don't fill long forms. They review + confirm what the
            consultant captured. Optional upload & intake is available later.
          </p>
          <div className="mt-5 rounded-2xl border border-border/60 dark:border-white/10 bg-muted/60 dark:bg-black/30 p-4 text-sm text-foreground/65 dark:text-white/65">
            Clear gates prevent confusion, protect scope, and keep momentum.
          </div>
        </Card>
      </div>

      <div className="mt-12">
        <PrimaryCTA copy={copy} />
      </div>
    </PageShell>);

};

